import { render, staticRenderFns } from "./AddEditButton.vue?vue&type=template&id=d1c5da32"
import script from "./AddEditButton.vue?vue&type=script&lang=js"
export * from "./AddEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports